import { type SocialLink } from '@doist/marketist'

import appendUTM from 'services/appendUTM'
import { isDefined } from 'services/is-defined'

import type { Plan } from 'types/user'

export function getFooterLinks({
    t,
    utm_campaign,
    userPlan,
    openRolesExist,
}: {
    t: (key: string) => string
    utm_campaign?: string
    userPlan?: Plan
    openRolesExist?: boolean
}) {
    const pricingTitle =
        userPlan && ['pro', 'free'].includes(userPlan) ? t('upgrade') : t('pricing')

    const resourceLinks = [
        { title: t('downloadApps'), href: '/downloads' },
        {
            title: t('helpCenter'),
            href: appendUTM('/help', { utm_campaign }),
        },
        {
            title: t('productivityMethods'),
            href: '/productivity-methods',
        },
        { title: t('integrations'), href: '/integrations' },
        { title: t('channelpartners'), href: '/channelpartners' },
        { title: t('developerApi'), href: 'https://developer.todoist.com' },
        { title: t('status'), href: 'https://status.todoist.com/' },
    ]

    const columnLinks = [
        {
            title: t('features'),
            links: [
                { title: t('howItWorks'), href: '/features' },
                { title: t('forTeams'), href: '/teams' },
                { title: pricingTitle, href: '/pricing' },
                { title: t('templates'), href: '/templates' },
            ].filter(isDefined),
        },
        {
            title: t('resources'),
            links: resourceLinks,
        },
        {
            title: t('company'),
            links: [
                {
                    title: t('aboutUs'),
                    href: appendUTM('https://doist.com', { utm_campaign }),
                },
                {
                    title: t('careers'),
                    href: appendUTM('https://doist.com/jobs', { utm_campaign }),
                    badge: openRolesExist ? t('weHiring') : undefined,
                },
                {
                    title: t('inspirationHub'),
                    href: appendUTM('/inspiration', { utm_campaign }),
                },
                {
                    title: t('press'),
                    href: appendUTM('https://doist.com/press/', { utm_campaign }),
                },
                {
                    title: t('twist'),
                    href: appendUTM('https://twist.com/', { utm_campaign }),
                },
            ],
        },
    ]

    const bottomLinks = [
        { title: t('security'), href: '/security' },
        { title: t('privacy'), href: 'https://doist.com/privacy' },
        { title: t('terms'), href: 'https://doist.com/terms-of-service' },
    ]

    const socialLinks: SocialLink[] = [
        {
            service: 'twitter',
            url: 'https://twitter.com/todoist',
            altText: t('todoistOnTwitter'),
        },
        {
            service: 'youtube',
            url: 'https://www.youtube.com/channel/UCQ_61yRKscCnkIJBPoR15EA',
            altText: t('todoistOnYoutube'),
        },
        {
            service: 'facebook',
            url: 'https://facebook.com/todoist',
            altText: t('todoistOnFacebook'),
        },
        {
            service: 'instagram',
            url: 'https://www.instagram.com/todoistofficial',
            altText: t('todoistOnInstagram'),
        },
    ]

    return {
        columnLinks,
        bottomLinks,
        socialLinks,
    }
}
